import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'src/app/local-storage.service';
import { Page } from 'src/app/page';
import { Subject } from 'src/models/subject.model';
import { CustomPaginationService } from 'src/services/custom-pagination.service';
import { SharedCaseService } from 'src/services/shared-case.service';
import { SubjectsService } from 'src/services/subjects.service';
import { ToastrImplService } from 'src/services/toastr.service';
import { UserService } from 'src/services/user.service';
import { AssigneDossierComponent } from '../assigne-dossier/assigne-dossier.component';
import { SearchItem } from '../subjects.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
   selector: 'app-registry',
   templateUrl: './registry.component.html',
   styleUrls: ['./registry.component.scss'],
})
export class RegistryComponent implements OnInit, OnChanges {
   areLoaded = false;

   @Output() loadingCompleted = new EventEmitter();
   @Output() emitPageData = new EventEmitter();
   @Output() rowClickedEvent = new EventEmitter();
   @Output() handleOpenDialogEvent = new EventEmitter();

   @Input() getFirstPageEvent: any = 0;
   @Input() getPreviousPageEvent: any;
   @Input() getNextPageEvent: any;
   @Input() getLastPageEvent: any;
   @Input() getPageInNewSizeEvent: any;
   @Input() applyFilterEvent: any;
   @Input() changeCenterEvent: any;
   @Input() object: any = { origin: '' };
   @Input() customFilterFormValue: any;
   @Input() filterInUse: boolean = false;

   readonly separatorKeysCodes: number[] = [COMMA, ENTER];
   public searchTerms: string[] = [];

   public globalFilter: any = '';
   public searchItems: SearchItem[] = [];
   page: Page<Subject> = new Page();
   myInput = '';
   isUserManager = false;
   fileUrl: any;
   subcenter = new FormControl();
   subcenterCsrId: any;
   subcenters = [];
   loggedIn: any;
   isMainCenterBelgrade = false;
   isUserDrugostepeni = false;
   paramsObject: any;
   loadParams = true;
   displayedColumns: string[] = ['registrationId', 'id', 'dateOfCreation', 'lastName', 'firstName', 'parentName', 'dateOfBirth', 'yearOfBirth', 'gender', 'jmbg', 'jmbp', 'status', 'familyDossier'];
   constructor(
      private sharedCaseService: SharedCaseService,
      private subjectsService: SubjectsService,
      private paginationService: CustomPaginationService,
      public router: Router,
      private localStorageService: LocalStorageService,
      private toastr: ToastrImplService,
      private route: ActivatedRoute,
      private userService: UserService,
      public dialog: MatDialog,
   ) {
      this.localStorageService.remove('case');

      this.clearSharedCaseService(); // Treba da se obrise da ne bi pamtio tabove o detaljima predmeta

      this.loggedIn = JSON.parse(this.localStorageService.get('loggedUser'));
      this.isUserDrugostepeni = userService.isUserDrugostepeni();
      this.isMainCenterBelgrade = this.loggedIn?.csrId === '1' ? true : false;
      this.isUserManager = this.userService.isUserManager();
      if (this.isUserManager) {
         this.displayedColumns.push('actions');
      }
      if (this.isUserDrugostepeni || this.isMainCenterBelgrade) {
         if (this.localStorageService.get('localStorageSubcenter') !== null) {
            const localStorageSubcenter = JSON.parse(this.localStorageService.get('localStorageSubcenter'));
            this.subcenterCsrId = localStorageSubcenter.id;
            this.subcenter.setValue(localStorageSubcenter);
         } else {
            this.subcenterCsrId = 0;
         }
      }
      this.getQueryParams();
   }
   ngOnChanges(changes: SimpleChanges): void {
      if (changes.getFirstPageEvent) {
         if (this.getFirstPageEvent === 0 && this.page.pageable.pageNumber !== 0) {
            this.doFilter();
         } else {
            this.getFirstPage();
         }
      } else if (changes.getLastPageEvent) {
         this.getLastPage();
      } else if (changes.getPreviousPageEvent) {
         this.getPreviousPage();
      } else if (changes.getNextPageEvent) {
         this.getNextPage();
      } else if (changes.getPageInNewSizeEvent) {
         this.getPageInNewSize(this.getPageInNewSizeEvent);
      } else if (changes.applyFilterEvent) {
         this.applyFilter(this.applyFilterEvent);
      } else if (changes.changeCenterEvent) {
         this.changeCenter(this.changeCenterEvent);
      }
   }

   ngOnInit(): void {}

   doFilter() {
      this.setQueryParams();
      const body = {
         pageId: this.page.pageable.pageNumber,
         sizeId: this.page.pageable.pageSize,
         csrId: this.isMainCenterBelgrade || this.isUserDrugostepeni ? this.subcenterCsrId : this.loggedIn?.csrId,
         searchData: (this.globalFilter === '' ? this.myInput : this.globalFilter) === '' ? [] : this.globalFilter === '' ? this.myInput : this.globalFilter,
         status: this.filterInUse ? this.customFilterFormValue.status : null,
         address: this.filterInUse && this.customFilterFormValue.address != '' ? this.customFilterFormValue.address : null,
      };
      if (!((this.isMainCenterBelgrade || this.isUserDrugostepeni) && this.subcenterCsrId === undefined)) {
         this.subjectsService.getFilteredPage(body).subscribe(page => {
            this.page = page;
            this.page.pageable.pagePerShow = page.number + 1;
            this.emitPageData.emit(this.page);
            for (const element of this.page.content) {
               if (element.dateOfBirth !== null) {
                  element.dateOfBirth = (element.dateOfBirth as any).replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
               }
               element.dateOfCreation = (element.dateOfCreation as any).replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
            }
            this.areLoaded = true;
            this.loadingCompleted.emit(true);
         });
      }
   }

   public getNextPage(): void {
      this.areLoaded = false;
      this.loadingCompleted.emit(false);

      this.page.pageable = this.paginationService.getNextPage(this.page);
      this.doFilter();
   }

   public getPreviousPage(): void {
      this.areLoaded = false;

      this.loadingCompleted.emit(false);
      this.page.pageable = this.paginationService.getPreviousPage(this.page);
      this.doFilter();
   }

   public getFirstPage(): void {
      this.areLoaded = false;

      this.loadingCompleted.emit(false);
      this.page.pageable = this.paginationService.getFirstPage(this.page);
      this.doFilter();
   }

   public getLastPage(): void {
      this.areLoaded = false;

      this.loadingCompleted.emit(false);
      this.page.pageable = this.paginationService.getLastPage(this.page);
      this.doFilter();
   }

   public getPageInNewSize(pageSize: any): void {
      this.areLoaded = false;

      this.loadingCompleted.emit(false);
      this.page.pageable = this.paginationService.getPageInNewSize(this.page, pageSize);
      this.doFilter();
   }

   applyFilter(filterValue: any) {
      this.globalFilter = filterValue;
      this.page.pageable.pageNumber = 0;
      this.doFilter();
   }

   clearSharedCaseService() {
      this.sharedCaseService.tabs = [];
      this.sharedCaseService.activeTab = null;
   }

   setQueryParams() {
      let params = {
         pageNum: null,
         size: null,
         filter: this.globalFilter === '' ? null : this.globalFilter,
         status: this.filterInUse ? this.customFilterFormValue.status : null,
         address: this.filterInUse && this.customFilterFormValue.address !== '' ? this.customFilterFormValue.address : null,
      };
      if (this.object.origin === undefined) {
         if (this.page.pageable.pageNumber !== 0) {
            params = {
               pageNum: this.page.pageable.pageNumber,
               size: this.page.pageable.pageSize,
               status: this.filterInUse ? this.customFilterFormValue.status : null,
               address: this.filterInUse && this.customFilterFormValue.address !== '' ? this.customFilterFormValue.address : null,
               filter: this.globalFilter === '' ? null : this.globalFilter,
            };
         }
         this.router.navigate([], {
            relativeTo: this.route,
            queryParams: params,
            replaceUrl: true,
         });
      }
   }

   getQueryParams() {
      this.route.queryParamMap.subscribe(params => {
         if (this.loadParams === true) {
            this.paramsObject = { ...params.keys, ...params };
            const param = this.paramsObject.params;
            this.page.pageable.pageNumber = param?.pageNum ? param?.pageNum : this.page.pageable.pageNumber;
            this.page.pageable.pageSize = param?.size ? param?.size : this.page.pageable.pageSize;

            if (param?.filter) {
               this.searchItems = [];
               this.globalFilter = Array.isArray(param?.filter) ? param?.filter : [param?.filter];
               for (const filter of this.globalFilter) {
                  this.searchItems.push({ name: filter });
               }
            }
            if (param?.status) {
               this.filterInUse = true;
               this.customFilterFormValue.status = param?.status;
            }
            if (param?.address) {
               this.filterInUse = true;
               this.customFilterFormValue.address = param?.address;
            }

            this.loadParams = false;
         }
      });
   }

   handleOpenDialog(element: any) {
      this.handleOpenDialogEvent.emit(element);
   }

   changeCenter(event: any) {
      this.subcenterCsrId = event?.id;
      this.getFirstPage();
   }

   onRowClicked(element: any) {
      this.rowClickedEvent.emit(element);
   }
}
